import axios from 'axios'
import { config } from '../Config/config'

const cariobatService = {
    getAllKategori: () => {
        const result = axios.get(config.apiUrl + '/kategoriObat')
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    getAllSegmentation: () => {
        const result = axios.get(config.apiUrl + 'segmentationObat')
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    getAllObat: () => {
        const result = axios.get(config.apiUrl + '/obat')
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    getAllFilter: (filter) => {
        const result = axios.post(config.apiUrl + '/obatFilter', filter)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }

            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    countData: () => {
        const result = axios.get(config.apiUrl + '/countObat')
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    }


}

export default cariobatService